/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Footer_Seller_TermsInputs */

const en_footer_seller_terms = /** @type {(inputs: Footer_Seller_TermsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seller Terms`)
};

const zh_hans1_footer_seller_terms = /** @type {(inputs: Footer_Seller_TermsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`卖家条款`)
};

const pt_br2_footer_seller_terms = /** @type {(inputs: Footer_Seller_TermsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Termos do Vendedor`)
};

const es_footer_seller_terms = /** @type {(inputs: Footer_Seller_TermsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Términos para vendedores`)
};

const fr_footer_seller_terms = /** @type {(inputs: Footer_Seller_TermsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conditions vendeurs`)
};

const de_footer_seller_terms = /** @type {(inputs: Footer_Seller_TermsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verkäuferbedingungen`)
};

const ru_footer_seller_terms = /** @type {(inputs: Footer_Seller_TermsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Условия для продавцов`)
};

const it_footer_seller_terms = /** @type {(inputs: Footer_Seller_TermsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Termini per i venditori`)
};

/**
* | output |
* | --- |
* | "Seller Terms" |
*
* @param {Footer_Seller_TermsInputs} inputs
* @param {{ locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }} options
* @returns {LocalizedString}
*/
export const footer_seller_terms = /** @type {((inputs?: Footer_Seller_TermsInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Footer_Seller_TermsInputs, { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh-Hans") return zh_hans1_footer_seller_terms(inputs)
	if (locale === "pt-BR") return pt_br2_footer_seller_terms(inputs)
	if (locale === "es") return es_footer_seller_terms(inputs)
	if (locale === "fr") return fr_footer_seller_terms(inputs)
	if (locale === "de") return de_footer_seller_terms(inputs)
	if (locale === "ru") return ru_footer_seller_terms(inputs)
	if (locale === "it") return it_footer_seller_terms(inputs)
	return en_footer_seller_terms(inputs)
});